import gql from 'graphql-tag';

export const FETCH_TEMPLATES = gql`
  query getTemplates(
    $query: String
    $after: String
    $before: String
    $first: Int
    $last: Int
  ) {
    templates(
      query: $query
      after: $after
      before: $before
      first: $first
      last: $last
    ) {
      nodes {
        uuid
        name
        notes {
          nodes {
            uuid
            text
            createdAt
            updatedAt
          }
        }
        description
        previewImage {
          url
        }
        user {
          email
          firstName
          lastName
        }
        recipients {
          nodes {
            uuid
            email
            fullName
          }
        }
        activityLogs {
          nodes {
            event
            eventDate
            id
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalPageCount
      totalCount
    }
  }
`;

export default {
  FETCH_TEMPLATES,
};
